"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TrashIcon = function TrashIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8947 1.94737C12.8947 1.42415 12.4706 1 11.9474 1H7.21053L7.10004 1.00637C6.62888 1.0611 6.26316 1.46152 6.26316 1.94737C6.26316 2.47059 6.68731 2.89474 7.21053 2.89474H11.9474L12.0579 2.88836C12.529 2.83364 12.8947 2.43321 12.8947 1.94737ZM16.2105 3.84211C16.7337 3.84211 17.1579 4.26626 17.1579 4.78947C17.1579 5.27532 16.7922 5.67574 16.321 5.73047L16.2105 5.73684V16.1579C16.2105 17.671 15.0268 18.9087 13.5354 18.9952L13.3684 19H5.78947C4.2764 19 3.03867 17.8163 2.9522 16.3248L2.94737 16.1579V5.73684C2.42415 5.73684 2 5.31269 2 4.78947C2 4.30363 2.36572 3.9032 2.83689 3.84848L2.94737 3.84211H3.89474H15.2632H16.2105ZM4.84211 5.73684H14.3158V16.1579L14.3094 16.2683C14.2546 16.7391 13.8538 17.1053 13.3684 17.1053H5.78947L5.67909 17.0989C5.20829 17.0441 4.84211 16.6432 4.84211 16.1579V5.73684ZM7.68421 7.15789C8.17005 7.15789 8.57048 7.52362 8.62521 7.99478L8.63158 8.10526V14.7368C8.63158 15.2601 8.20743 15.6842 7.68421 15.6842C7.19837 15.6842 6.79794 15.3185 6.74322 14.8473L6.73684 14.7368V8.10526C6.73684 7.58205 7.16099 7.15789 7.68421 7.15789ZM12.4147 7.99478C12.36 7.52362 11.9595 7.15789 11.4737 7.15789C10.9505 7.15789 10.5263 7.58205 10.5263 8.10526V14.7368L10.5327 14.8473C10.5874 15.3185 10.9878 15.6842 11.4737 15.6842C11.9969 15.6842 12.4211 15.2601 12.4211 14.7368V8.10526L12.4147 7.99478Z",
    fill: color
  }));
};

var _default = TrashIcon;
exports.default = _default;